// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"335":"4960090f","586":"195a3b9d","623":"6b8774c0","787":"688ec503","879":"f06deab5"}[chunkId] + ".chunk.js";
};